import { Colors } from '@sigma-frontend-libs/commons'

import { components, dateFields, icons, permissionPresets, placements, services } from '@/utils'

import badge from '@/components/badge'
import squircle from '@/components/icon/squircle'
import tabsBody from '@/components/services/sendings/outgoing/details/tabs/_body'
import tabsHeader from '@/components/services/sendings/outgoing/details/tabs/_header'
import resendButton from '@/components/services/sendings/outgoing/resendButton'
import price from '@/components/services/sendings/price'
import { sendingsStatuses } from '@/components/services/sendings/utils'
import sticker from '@/components/sticker'
import tag from '@/components/tag'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderFallbacksBadge(h) {
  if (this.fallbacksCount !== undefined && this.fallbacksCount > 0) {
    return h(
      badge,
      {
        props: {
          value: this.fallbacksCount,
          tooltip: this.getTranslate(`${services.sendings}.tooltips.fallbacks`, { count: this.fallbacksCount }),
          rounded: true,
          placement: {
            [placements.bottom]: true,
            [placements.right]: true
          },
          offset: 'out'
        }
      }
    )
  }
}
function renderModerationBadge(h) {
  if (this.messageOnModeration) {
    return h(
      badge,
      {
        props: {
          icon: icons.pause,
          color: Colors.warning,
          tooltip: this.getTranslate(`${services.sendings}.tooltips.moderation`),
          rounded: true,
          placement: {
            [placements.top]: true,
            [placements.right]: true
          },
          offset: 'out'
        }
      }
    )
  }
}

function renderStatus(h) {
  const status = this.value?.state?.status

  return h(
    'div',
    {
      class: 'position--relative'
    },
    [
      h(
        squircle,
        {
          props: {
            icon: sendingsStatuses[status]?.icon,
            color: sendingsStatuses[status]?.color,
            tooltip: this.getTranslate(`${services.sendings}.statuses.${status}`)
          }
        }
      ),
      renderModerationBadge.call(this, h),
      renderFallbacksBadge.call(this, h)
    ]
  )
}
function renderRecipient(h) {
  const type = this.value?.type
  const replacement = this.getReplacement('type')
  const badge = this.getReplacementBadge(replacement)
  if (replacement && badge && badge.badgeProps) {
    badge.badgeProps.placement = {
      [placements.bottom]: true,
      [placements.left]: true
    }
  }

  return h(
    sticker,
    {
      props: {
        value: this.value?.payload?.recipient,
        label: this.getTranslate(`${services.sendings}.labels.recipient`),
        iconTooltip: this.getTranslate(`${services.sendings}.types.${replacement || type}`),
        iconSVG: type,
        color: type,
        copy: true,
        ...badge
      }
    }
  )
}
function renderOwner(h) {
  if (this.canViewOwner) {
    return h(
      owner,
      {
        props: {
          value: this.value?.Owner?.id || this.value?.OwnerId,
          accept: permissionPresets.meUp,
          readonly: !this.canViewOwner,
          copy: this.canViewOwner,
          compact: this.viewport.size.width < 1200
        }
      }
    )
  }
}
function renderSender(h) {
  if (this.viewport.size.width > 1200) {
    const replacement = this.getReplacement('payload.sender')
    const badge = this.getReplacementBadge(replacement)

    return h(
      sticker,
      {
        props: {
          value: this.value?.payload?.sender,
          label: this.getTranslate(`${services.sendings}.labels.sendername`),
          tooltip: replacement,
          copy: true,
          ...badge
        }
      }
    )
  }
}
function renderText(h) {
  if (this.viewport.size.width > 600) {
    const replacement = this.getReplacement('payload.text')
    const badge = this.getReplacementBadge(replacement)

    return h(
      'div',
      {
        class: `${services.sendings}-item__text`
      },
      [
        h(
          sticker,
          {
            props: {
              value: this.value?.payload?.text,
              label: this.getTranslate(`${services.sendings}.labels.text`),
              tooltip: replacement,
              copy: true,
              minWidth: 100,
              ...badge
            }
          }
        )
      ]
    )
  }
}
function renderExternalId(h) {
  const ids = this.value?.state?.detailed?.ids
  if (ids && ids.length) {
    const [ id1, id2 ] = ids[0].split(':')

    return h(
      sticker,
      {
        props: {
          value: { externalId: id2 || id1 },
          label: this.getTranslate(`${services.sendings}.labels.external.id`),
          pathToTitle: 'externalId',
          copy: true,
          width: 'fit-content'
        }
      }
    )
  }

  return h('div')
}

function renderResendButton(h) {
  if (this.checkPermissions(`advanced.${services.sendings}.create`)) {
    return h(
      resendButton,
      {
        props: { value: this.value }
      }
    )
  }
}
function renderButtons(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__buttons`
    },
    [ renderResendButton.call(this, h) ]
  )
}

function renderOperator(h) {
  if (this.viewport.size.width > 1680) {
    const { group, operator, mcc, mnc } = this.value?.meta?._recipientData || {}
    const value = group || operator || [ mcc, mnc ].filter(Boolean).join(' ')

    if (value) {
      return h(
        sticker,
        {
          props: {
            value,
            label: this.getTranslate(`${services.sendings}.headers.operator`),
            minWidth: this.viewport.size.width > 1920 ? 200 : 120,
            maxWidth: this.viewport.size.width > 1920 ? 200 : 120
          }
        }
      )
    }
  }
}
function renderProvider(h) {
  if (this.viewport.size.width > 1680) {
    if (this.checkPermissions(`advanced.${services.providers}.get`, permissionPresets.resellerUp)) {
      const id = this.value?.meta?._routing?.provider
      if (id) {
        return h(
          sticker,
          {
            props: {
              value: id,
              label: this.getTranslate(`${services.sendings}.labels.provider`),
              service: services.providers,
              copy: true,
              minWidth: this.viewport.size.width > 1920 ? 200 : 140,
              maxWidth: this.viewport.size.width > 1920 ? 200 : 140
            }
          }
        )
      }
    }
  }
}

function renderTextMisc(h) {
  return h(
    tag,
    {
      props: {
        label: this.textMisc,
        tooltip: this.getTranslate(`${services.sendings}.tooltips.segments`),
        fluid: true
      }
    }
  )
}
function renderPrice(h) {
  return h(
    price,
    {
      props: {
        value: this.value
      }
    }
  )
}
function renderMisc(h) {
  if (this.viewport.size.width > 1460) {
    return h(
      'div',
      {
        class: `${services.sendings}-item__misc`
      },
      [
        renderTextMisc.call(this, h),
        renderPrice.call(this, h)
      ]
    )
  }
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value,
        icon: this.viewport.size.width > 1200
      }
    }
  )
}
function renderUpdatedAt(h) {
  if (this.viewport.size.width > 1320) {
    return h(
      date,
      {
        props: {
          value: this.value,
          field: dateFields.updatedAt
        }
      }
    )
  }
}

function renderHeaderBeforeText(h) {
  return h(
    'div',
    {
      class: {
        [`${services.sendings}-item__header--before-text`]: true,
        [`${services.sendings}-item__header--before-text--admin`]: this.canViewOwner
      }
    },
    [
      renderStatus.call(this, h),
      renderRecipient.call(this, h),
      renderOwner.call(this, h),
      renderSender.call(this, h)
    ]
  )
}
function renderHeaderAfterText(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__header--after-text`
    },
    [
      renderOperator.call(this, h),
      renderProvider.call(this, h),
      renderMisc.call(this, h),
      renderCreatedAt.call(this, h),
      renderUpdatedAt.call(this, h)
    ]
  )
}
function renderHeaderContent(h) {
  if (this.providers) {
    return [
      renderStatus.call(this, h),
      renderRecipient.call(this, h),
      renderExternalId.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  }

  return [
    renderHeaderBeforeText.call(this, h),
    renderText.call(this, h),
    renderHeaderAfterText.call(this, h)
  ]
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: {
        [`${services.sendings}-item__header`]: true,
        [`${services.sendings}-item__header--providers`]: this.providers,
        [`${services.sendings}-item__header--moderation`]: this.messageOnModeration
      }
    },
    [ renderHeaderContent.call(this, h) ]
  )
}

function renderTabsHeader(h) {
  return h(
    tabsHeader,
    {
      class: 'px-2',
      props: {
        value: this.currentTab,
        tabs: this.tabs
      },
      on: {
        input: event => {
          this.currentTab = event
        }
      },
      slots: 'header'
    }
  )
}
function renderTabsBody(h) {
  return h(
    tabsBody,
    {
      props: {
        value: this.currentTab,
        data: this.value,
        tabs: this.tabs
      },
      on: {
        input: event => {
          this.currentTab = event
        }
      }
    }
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__body`
    },
    [
      renderTabsHeader.call(this, h),
      renderTabsBody.call(this, h),
      renderButtons.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components['expansion-panel'],
    {
      class: `${services.sendings}-item`,
      scopedSlots: {
        header: () => renderHeader.call(this, h),
        default: () => renderBody.call(this, h)
      },
      on: {
        click: this.clickHandler
      },
      key: this.value.id
    }
  )
}
